/**
 *  If the value is missing outputs the placeholder text
 * 
 * '' => {placeholder}
 * 'foo' => 'foo'
 */

function placeholder (input, property) {
  return ( input === undefined || input === '' ) ? property : input;
}

export default placeholder



// WEBPACK FOOTER //
// core-build-local/filters/string/placeholder.js